subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
// 1. Define the default shipping time
  let shippingTime = "1-3 dias úteis";
  
  // 2. Get the inventory quantity from the variant object
  const variantQuantity = data.variant.inventory_quantity;

  // 3. Apply the conditional logic
  if (variantQuantity <= 0) {
    shippingTime = "6-10 dias úteis";
  }

  // 4. Select the target span element
  const shippingTimeElement = document.getElementById('shipping-time');

  // 5. Update the text content of the span
  if (shippingTimeElement) {
    shippingTimeElement.textContent = shippingTime; 
  }
})